import { createFileRoute, redirect } from "@tanstack/react-router";
import { PlaceRoute } from "@/components/place/PlaceRouteView";
import { placeLoader, TRAIN_FACTORY_HUB_IDS } from "@/routes/place.$id";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

export const Route = createFileRoute("/fi/place/$id")({
  beforeLoad: ({ params }) => {
    if (TRAIN_FACTORY_HUB_IDS.has(params.id)) throw redirect({ to: "/train-factory" });
  },
  // Same data as the English route; the loader detects the /fi path and swaps
  // in the stored Finnish translations server-side, so the Finnish copy ships
  // inside the first HTML response (indexable, no hydration swap).
  loader: placeLoader,
  head: ({ params, loaderData }) => {
    const url = `https://whatfinland.com/fi/place/${params.id}`;
    const item = (loaderData as any)?.item;
    const title = item ? `${item.name} — what · ${item.area}` : "Kohde — what";
    const description = item?.description ?? "Löydä Suomen parhaat paikat, ravintolat ja tapahtumat.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: item?.section === "happening" ? "event" : "article" },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
        { name: "twitter:card", content: "summary_large_image" },
        ...(item?.image ? [
          { property: "og:image", content: item.image },
          { name: "twitter:image", content: item.image },
        ] : []),
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflangLinks(`/fi/place/${params.id}`),
      ],
    };
  },
  component: PlaceRoute,
});
